import React from 'react';

import DesktopPageWithJob from './DesktopPageWithJob';
import DesktopPageWithoutJob from './DesktopPageWithoutJob';

import './StartCandidateJourneyDesktopPage.scss';

const StartCandidateJourneyDesktopPage = ({
    menuInformation,
    getCandidateJourneyDuration,
    START_JOURNEY_STEPS,
    handleStartCandidateJourney,
    agencyName,
    jobOpportunity,
    isWithOpportunity,
    showContent,
    role,
}) =>  (
    <>
        { isWithOpportunity
            ?
                <DesktopPageWithJob
                    menuInformation={menuInformation}
                    getCandidateJourneyDuration={getCandidateJourneyDuration}
                    START_JOURNEY_STEPS={START_JOURNEY_STEPS}
                    handleStartCandidateJourney={handleStartCandidateJourney}
                    agencyName={agencyName}
                    jobOpportunity={jobOpportunity}
                    showContent={showContent}
                />
            :
                <DesktopPageWithoutJob
                    handleStartCandidateJourney={handleStartCandidateJourney}
                    role={role}
                />
        }
    </>
);

export default StartCandidateJourneyDesktopPage;
